import React from 'react'
import Card from 'react-bootstrap/Card';
import List from "../../../styleHelper/List"

export default function PriceCard(props){
    return(
        <Card className={props.offer ? "pricePackCard offer" : "pricePackCard"}>
            <Card.Header>
                    <h2>{props.title}</h2>
                    <div className="pricePackTime">{props.time}</div>
                    <div className="priceBox">{props.price}<span className="curency">تومان</span></div>
                </Card.Header>
            <Card.Body>
                <List className="withDivider description" listItems={props.list}/>
                <div className="btns"><a href="/auth" className="btn btn-primary">شروع کنید</a></div>
            </Card.Body>
        </Card>
    )
}